/**
 * Campaign Generation — API.
 */
import { http } from "@/shared/api/http";
import type { BeginProductionPayload, GenerationState } from "./types";

export const beginProduction = (
  blueprintId: string,
  payload: BeginProductionPayload = {},
): Promise<GenerationState> =>
  http<GenerationState>(`/orchestration/blueprints/${blueprintId}/generate`, {
    method: "POST",
    body: payload,
  });

export const getGenerationState = (
  blueprintId: string,
): Promise<GenerationState> =>
  http<GenerationState>(`/orchestration/blueprints/${blueprintId}/generation`);
